import type { FieldBinding } from '@doer/frontend-components/creativity-editor';
import { pieceMapEntries, type PieceBindingEntry } from '../binders';

export type { PieceBindingEntry };

export function buildPieceIdToBindingMap(fieldBindings: FieldBinding[]): Map<string, PieceBindingEntry> {
  const map = new Map<string, PieceBindingEntry>();
  for (const binding of fieldBindings) {
    for (const [pieceId, entry] of pieceMapEntries(binding)) {
      map.set(pieceId, entry);
    }
  }
  return map;
}

/** Immutably writes a value at a dot-separated path. */
export function setAtPath(target: Record<string, unknown>, path: string, value: unknown): Record<string, unknown> {
  if (!path) return target;

  const keys = path.split('.');
  const root: Record<string, unknown> = { ...target };
  let cursor = root;

  for (let i = 0; i < keys.length - 1; i++) {
    const key = keys[i];
    const existing = cursor[key];
    cursor[key] = existing != null && typeof existing === 'object' ? { ...(existing as Record<string, unknown>) } : {};
    cursor = cursor[key] as Record<string, unknown>;
  }

  cursor[keys[keys.length - 1]] = value;
  return root;
}
